export default { sha: 'bdfd70d4557bd6c64ecb44e67155a692941e1ba0', buildNumber: 'undefined' }
